<template>
  <Form
    :action-type="actionType"
    :subtitle="subtitle"
    :disabled="wasDisabled"
    :fallback-link="fallbackLink"
    :form-body="form"
    :show-preloader="isLoadingNow"
    @on-submit="submit"
    @on-edit="setEditMode(true)"
    @on-cancel="setEditMode(false)"
  >
    <template slot="top-panel-buttons">
      <div :class="productsButtonCss">
        <button
          class="btn btn-primary"
          @click="productsModalWasOpened = true"
        >
          <i class="fa fa-dropbox"></i>
          Товары
        </button>
      </div>
    </template>
    <template slot="fields">
      <ProviderProductsModal
        v-if="productsModalWasOpened"
        :action-type="actionType"
        :init-adding-products="changedProducts.adding"
        :init-removing-products="changedProducts.removing"
        @close="productsModalWasOpened = false"
        @on-products-change="setChangedProducts"
      />
      <div v-if="productsWereChanged" class="row form-group">
        <div class="col-lg-12">
          <div class="col-lg-6">
            <p class="form__notice_products"><b>{{ productsNotice }}</b></p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div
            v-for="(value, key, index) in formsFields.provider.labels"
            :key="index"
            class="col-lg-6 form-group"
          >
            <fieldset>
              <label>
                {{ value }}
                <span
                  v-if="isRequiredField(validationSchemas.provider[key])"
                  class="field__label_required"
                  >*</span
                >
              </label>
              <input
                class="form-control"
                :name="key"
                :maxlength="formsFields.provider.maxLength[key]"
                placeholder="Отсутствует"
                :disabled="actionType === 'read'"
                v-model.trim="form.provider[key]"
              />
            </fieldset>
          </div>
        </div>
      </div>
      <Sublist subtitle="Реквизиты">
        <template slot="fields">
          <div class="row">
            <div class="col-lg-12">
              <div
                v-for="(value, key, index) in formsFields.requisites.labels"
                :key="index"
                class="col-lg-6 form-group"
              >
                <fieldset>
                  <label>
                    {{ value }}
                    <span
                      v-if="isRequiredField(validationSchemas.requisites[key])"
                      class="field__label_required"
                      >*</span
                    >
                  </label>
                  <input
                    class="form-control"
                    placeholder="Отсутствует"
                    :name="key"
                    :maxlength="formsFields.requisites.maxLength[key]"
                    :disabled="actionType === 'read'"
                    v-model.trim="form.requisites[key]"
                  />
                </fieldset>
              </div>
            </div>
          </div>
        </template>
      </Sublist>
    </template>
  </Form>
</template>

<script>
import { validationMixin } from "vuelidate";
import validationSchemas from "@/business/validation-schemas";
import { providerService } from "@/business/api-services";

import Sublist from "@/_shared/features/form/Sublist";
import Form from "@/_shared/widgets/Form";
import ProviderProductsModal from "@/business/components/ProviderProductsModal";

import { useForm, useNotification } from "@/_shared/mixins";
import { formsFields } from "@/business/constants";

import { objectHelper } from "@/_shared/utils";
const { createFromKeys } = objectHelper;
export default {
  mixins: [
    validationMixin,
    useForm,
    useNotification,
  ],
  components: {
    Form,
    Sublist,
    ProviderProductsModal,
  },
  data() {
    return {
      changedProducts: {
        adding: [],
        removing: [],
      },
      productsModalWasOpened: false,
      formsFields,
      validationSchemas,
      fallbackLink: "/providers",
      entityName: {
        readonly: "Поставщик",
        modify: "поставщика",
      },
      form: {
        provider: createFromKeys(formsFields.provider.labels),
        requisites: createFromKeys(formsFields.requisites.labels),
      },
    };
  },
  validations() {
    return {
      form: {
        provider: validationSchemas.provider,
        requisites: validationSchemas.requisites,
      },
    };
  },
  created() {
    const addingFields = {
      provider: createFromKeys(this.formsFields.provider.labels),
      requisites: createFromKeys(this.formsFields.requisites.labels),
    };
    this.setFormFields(addingFields, providerService.get);
  },
  computed: {
    productsButtonCss() {
      return {
        'top-panel__button_products': this.actionType !== 'add',
      };
    },
    productsWereChanged() {
      return !!(this.changedProducts.removing.length > 0 ||
        this.changedProducts.adding.length > 0);
    },
    productsNotice() {
      const addCounter = this.changedProducts.adding.length;
      const removeCounter = this.changedProducts.removing.length;
      const notice = `Товары поставщика были обновлены (добавлено: `
        + `${addCounter}; удалено: ${removeCounter})`;
      return notice;
    },
  },
  methods: {
    setChangedProducts(values = {}) {
      this.changedProducts = values;
      this.productsModalWasOpened = false;
    },
    async submit() {
      const callback = async () => (
        await providerService[this.actionType](this.form, this.changedProducts)
        .catch((error) => {
          throw new Error(error.message);
        })
      );
      await this.sendForm(callback);
    },
  },
};
</script>

<style scoped>
.top-panel__button_products {
  margin-left: 1em;
}
@keyframes notice-appearing {
  from {
    opacity: 0;
    line-height: 0;
  }
}
.form__notice_products {
  animation: notice-appearing 0.3s;
}
</style>



// WEBPACK FOOTER //
// src/business/pages/ProviderForm.vue